// Logique d'affichage du patrimoine : tons des états, marqueurs de la carte, montants en francs CFA,
// jour civil courant (Libreville), paramètres des filtres de l'inventaire.
import { formaterFrancs, type EtatBien, type EtatMaintenance, type EtatSortie, type ConstatInventaire } from '@cc/contrats';
import type { MarqueurCarte, TonEtat } from '@cc/ui';
import type { CarteBiens } from './api';

export const TON_BIEN: Record<EtatBien, TonEtat> = { en_service: 'ok', en_maintenance: 'attente', hors_service: 'retard', sortie_demandee: 'signer', sorti: 'neutre' };
export const TON_MAINTENANCE: Record<EtatMaintenance, TonEtat> = { planifiee: 'attente', realisee: 'ok', annulee: 'neutre' };
export const TON_SORTIE: Record<EtatSortie, TonEtat> = { demandee: 'signer', validee: 'ok', refusee: 'neutre' };
export const TON_CONSTAT_INVENTAIRE: Record<ConstatInventaire, TonEtat> = { present: 'ok', absent: 'retard', deplace: 'attente', endommage: 'attente' };

export const francs = (v: number | null | undefined) => (v === null || v === undefined ? 'non renseigné' : formaterFrancs(v));

/** Jour civil de Libreville (UTC + 1). */
export function aujourdhuiIso(maintenant = new Date()): string {
  return new Date(maintenant.getTime() + 3_600_000).toISOString().slice(0, 10);
}

/** Paramètres de la requête de l'inventaire à partir des filtres affichés (valeurs vides ignorées). */
export function parametresInventaire(f: Record<string, string>): Record<string, string> {
  const p: Record<string, string> = { limite: '500' };
  for (const [k, v] of Object.entries(f)) if (v) p[k] = v;
  return p;
}

/** Marqueurs de la carte des biens : hors service ou sortie demandée en « retard », en maintenance en « autre ». */
export function marqueursBiens(c: CarteBiens | undefined): MarqueurCarte[] {
  return (c?.features ?? []).map((f, i) => ({
    id: f.properties.id,
    numero: i + 1,
    longitude: f.geometry.coordinates[0],
    latitude: f.geometry.coordinates[1],
    libelle: `${f.properties.reference} · ${f.properties.designation} (${f.properties.categorie_libelle})`,
    ton: f.properties.etat === 'hors_service' || f.properties.etat === 'sortie_demandee' ? ('retard' as const) : f.properties.etat === 'en_maintenance' ? ('autre' as const) : ('ouvert' as const),
  }));
}
